import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPushimeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 20,
	viewBox: "0 0 14 20",
	fill: "#323338",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_5747",
		"data-name": "Group 5747",
		transform: "translate(-5 -2)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_8284",
			"data-name": "Path 8284",
			d: "M17,6H15V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6H7A2.006,2.006,0,0,0,5,8V19a2.006,2.006,0,0,0,2,2,1,1,0,0,0,2,0h6a1,1,0,0,0,2,0,2.006,2.006,0,0,0,2-2V8A2.006,2.006,0,0,0,17,6ZM8.75,18h0A.755.755,0,0,1,8,17.25V9.75A.755.755,0,0,1,8.75,9h0a.755.755,0,0,1,.75.75v7.5A.755.755,0,0,1,8.75,18ZM12,18h0a.755.755,0,0,1-.75-.75V9.75A.755.755,0,0,1,12,9h0a.755.755,0,0,1,.75.75v7.5A.755.755,0,0,1,12,18ZM13.5,6h-3V3.5h3Zm1.75,12h0a.755.755,0,0,1-.75-.75V9.75A.755.755,0,0,1,15.25,9h0a.755.755,0,0,1,.75.75v7.5A.755.755,0,0,1,15.25,18Z"
		})
	})
});
export { SvgPushimeIcon as ReactComponent };
